<a class="support-bubble"
   [class.support-bubble--expanded]="expanded"
   [href]="url"
   target="_blank"
   rel="noopener noreferrer"
   [title]="label"
   [attr.aria-label]="label">
  <i class="support-bubble__icon" [ngClass]="icon"></i>
  <span class="support-bubble__text">{{ label }}</span>
</a>
